
import { BASE_URL } from "../../helpers/config";
import { showToast, showAlert } from "../../utils/helpers/ShowToast";
import authorizedAxios from "../../helpers/authorizedAxios";
import { fetchProducts } from "../productAction";
import { fetchProductGroups } from "../productGroupAction";
export const SET_PRODUCTRECIPES = "SET_PRODUCTRECIPES";
export const SET_PRODUCTRECIPES_LOADING = "SET_PRODUCTRECIPES_LOADING";
export const SET_PRODUCTRECIPES_ERROR = "SET_PRODUCTRECIPES_ERROR";

export const fetchRecipeSources = (limit = 500, search = "") => {
  return async (dispatch) => {
    dispatch({ type: SET_PRODUCTRECIPES_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/product-recipes", {
        params: { limit, page: 1, search },
      });

      return response?.data?.data?.data || [];
    } catch (error) {
      dispatch({
        type: SET_PRODUCTRECIPES_ERROR,
        error: error?.response?.data || "Daftar resep sumber gagal dimuat."
      });
      return null;
    } finally {
      dispatch({ type: SET_PRODUCTRECIPES_LOADING, status: false });
    }
  };
};

export const fetchProductRecipes = (limit = 100, page = 1, search = "") => {
  return async (dispatch) => {
    dispatch({ type: SET_PRODUCTRECIPES_LOADING, status: true });

    try {
      const response = await authorizedAxios.get(
        "/product-recipes?limit=" + limit + "&page=" + page + "&search=" + search
      );

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_PRODUCTRECIPES,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PRODUCTRECIPES_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_PRODUCTRECIPES_LOADING, status: false });
    }
  };
};

export const getProductRecipeById = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PRODUCTRECIPES_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/product-recipes/" + id);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_PRODUCTRECIPES,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PRODUCTRECIPES_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_PRODUCTRECIPES_LOADING, status: false });
    }
  };
};

export const addProductRecipe = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_PRODUCTRECIPES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post(`${BASE_URL}/product-recipes`, data), {
        loading: "Menyimpan data...",
        success: "Data product recipe berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data product recipe berhasil ditambahkan!"
        });
        dispatch(fetchProductRecipes());
        dispatch(fetchProducts());
        dispatch(fetchProductGroups());
        return true;
      }
      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PRODUCTRECIPES_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
      return false;
    } finally {
      dispatch({ type: SET_PRODUCTRECIPES_LOADING, status: false });
    }
  };
};

export const updateProductRecipe = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_PRODUCTRECIPES_LOADING, status: true });
    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/product-recipes/${id}`, data), {
        loading: "Mengupdate data...",
        success: "Data product recipe berhasil diupdate!",
        error: (err) => err?.response?.data?.message || "Gagal mengupdate data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data product recipe berhasil diupdate!"
        });
        dispatch(fetchProductRecipes());
        dispatch(fetchProducts());
        dispatch(fetchProductGroups());
        return true;
      }
      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PRODUCTRECIPES_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
      return false;
    } finally {
      dispatch({ type: SET_PRODUCTRECIPES_LOADING, status: false });
    }
  };
};

export const deleteProductRecipe = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PRODUCTRECIPES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.delete(`${BASE_URL}/product-recipes/${id}`), {
        loading: "Menghapus data...",
        success: "Data product recipe berhasil dihapus!",
        error: (err) => err?.response?.data?.message || "Gagal menghapus data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data product recipe berhasil dihapus!"
        });
        dispatch(fetchProductRecipes());
        dispatch(fetchProducts());
        dispatch(fetchProductGroups());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PRODUCTRECIPES_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
    } finally {
      dispatch({ type: SET_PRODUCTRECIPES_LOADING, status: false });
    }
  };
};
